import _ from '@luna/lodash';
import { getFeatureConfig } from '@luna/feature-config';

const SERVER_THOUSAND_SEPARATOR = '';
const SERVER_DECIMAL_SEPARATOR = ',';

export const formatAmount = (amountStr = ''): string => {
    const thousandSeparator = getFeatureConfig((config) => config.base.thousandSeparator);
    const decimalSeparator = getFeatureConfig((config) => config.base.decimalSeparator);

    return amountStr
        .replace(getSeparatorRegex(thousandSeparator), SERVER_THOUSAND_SEPARATOR)
        .replace(getSeparatorRegex(decimalSeparator), SERVER_DECIMAL_SEPARATOR);
};

function getSeparatorRegex(separator: string): RegExp {
    return new RegExp(_.escapeRegExp(separator), 'g');
}
